import React from "react";
import { Button } from "@material-ui/core";
import { pushAnalytics } from 'Helpers/analytics-helpers'
import { HomeContainer } from "./Home.style";
import Description from "./Description";
import Story from "./Story";
import Races from "./Races";
import Paced from "./Paced"
import Classes from "./Classes"
import IntroVideo from "Assets/images/Home/NW_Intro.mp4";
import { useTranslation } from 'react-i18next'
import { BREAKPOINTS_VALUE } from "Styles/Constants";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { createSteamUrl } from '@fe-packages/components-and-utilities'
import { openDownloadUrl } from 'Helpers/Utils';

function Home() {
  const { t: translate } = useTranslation();
  let history = useHistory();
  const language = useSelector(state => state.Auth.lang || "en");

  const handleClick = () => {
    pushAnalytics({
			element_name: 'play-now',
			category: 'cta',
			action: 'click',
			label: 'play-now',
		})
    history.replace("/" + language + "/download")
    openDownloadUrl(language)
  }

  return (
    <React.Fragment>
      <HomeContainer>
        <div className="bg-image">
          {window.innerWidth >= BREAKPOINTS_VALUE.PHABLET && <video width="100%" height="100%" autoPlay muted loop className="video-viewport">
            <source src={IntroVideo} type="video/mp4" />
          </video>}
          <div className="image" />
          <div className="text">{translate("home.header.description")}</div>
          <Button onClick={handleClick} className="play-now">{translate('home.play_now')}</Button>
          <Button href={createSteamUrl({id: 109600, utm_campaign: 'nw_organic_ww', utm_medium: 'web'})} className={`also-available-on-steam also-available-on-steam--${language}`}>{translate('home.also_available_on')}<span className="also-available-on-steam__steam-icon"/></Button>
        </div>
      </HomeContainer>
      <Description />
      <Story />
      <Races />
      <Classes />
      <Paced />
    </React.Fragment>
  )
}

export default Home;
